"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//

var Chart = require("chart.js");

exports.default = {
  props: ["data"],

  mounted: function mounted() {
    this.render();
  },


  methods: {
    render: function render() {
      var myChart = new Chart(this.$refs.canvas, {
        type: "horizontalBar",
        data: {
          labels: this.data.chartsData.labels,
          datasets: [{
            label: "Total of answers",
            backgroundColor: this.data.chartsData.colors[0],
            data: this.data.chartsData.totalAnswers
          }, {
            label: "Answered Yes",
            backgroundColor: this.data.chartsData.colors[1],
            data: this.data.chartsData.answeredYes
          }, {
            label: "Answered No",
            backgroundColor: this.data.chartsData.colors[2],
            data: this.data.chartsData.answeredNo
          }]
        },
        options: {
          legend: { display: false },
          title: {
            display: true,
            text: this.data.chartsData.name
          },
          scales: {
            xAxes: [{
              ticks: {
                suggestedMax: this.setMax(this.data.chartsData.totalAnswers),
                beginAtZero: true
              }
            }]
          }
        }
      });
    },
    setMax: function setMax(data) {
      var max = 0;

      var compareMax = data[0] > data[1] ? data[0] : data[1];

      if (compareMax <= 5) {
        max = 5;
      } else if (compareMax > 5 && compareMax <= 10) {
        max = 10;
      } else if (compareMax > 10 && compareMax <= 15) {
        max = 15;
      } else if (compareMax > 20 && compareMax <= 25) {
        max = 25;
      } else {
        max = compareMax;
      }

      return max;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/reports/charts/elements/CompareReportPercentChart.vue
// module id = atk5
// module chunks = 0 1